import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from 'ui';
import { IconLogout } from 'ui/Icons';

interface LogoutButtonProps {
  fullWidth?: boolean;
}

const LogoutButton = ({ fullWidth = false }: LogoutButtonProps) => {
  const navigate = useNavigate();
  const handleLogout = useCallback(() => {
    navigate('/signout');
  }, [navigate]);
  return (
    <PrimaryButton
      onClick={handleLogout}
      sx={{
        maxWidth: fullWidth ? '100%' : '25ch',
        minWidth: '15ch',
        flex: 1,
        width: fullWidth ? '100%' : 'auto',
      }}
    >
      <IconLogout
        fontSize='small'
        sx={{ display: { xs: 'none', sm: 'block' }, mr: 1 }}
      />
      Logga ut
    </PrimaryButton>
  );
};

export default LogoutButton;
